// <dynamic-product-tabs>
import { cachedFetch } from 'theme';
class DynamicProductTabs extends HTMLElement {
	connectedCallback() {
		let forms = Array.from(document.forms).filter((form) => {
			return form.getAttribute('id')?.includes('product-form-main-');
		});
		const mainForm = forms.shift();
		if (mainForm) {
			mainForm.addEventListener('variant:change', this.onVariantChange.bind(this));
		}
	}
	get productHandle() {
		return this.getAttribute('product-handle');
	}
	get sectionId() {
		return this.getAttribute('section-id');
	}
	async onVariantChange(event) {
		const variant = event?.detail.variant;
		const responseContent = await (
			await cachedFetch(
				`${window.Shopify.routes.root}products/${this.productHandle}?variant=${variant.id}&section_id=${this.sectionId}`,
			)
		).text();
		const newContent = new DOMParser().parseFromString(responseContent, 'text/html');
		this.replaceContent(newContent);
	}
	replaceContent(newContent) {
		this.querySelectorAll('[dynamic-block-id]').forEach((oldTabNode) => {
			const newTabNode = newContent.querySelector(`[dynamic-block-id="${oldTabNode.getAttribute('dynamic-block-id')}"]`);
			if (newTabNode) {
				oldTabNode.innerHTML = newTabNode.innerHTML;
			}
		});
	}
}
customElements.define('dynamic-product-tabs', DynamicProductTabs);
